/*
* @Author: gujianghua
* @Date:   2018-07-21 18:00:58
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-09-13 18:22:11
*/
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'
const v2 = BASE_API

export default {
	getCourseList: function getCourseList(data) {
		return service({
			url: '/cloud/course/v1/admin/course/pageList',
			method: 'post',
			data: data
		})
	},
	//获取列表
  	getCourseTypeList: (data) => {
	    return service({
	      url: '/cloud/course/v1/admin/course/product/type/list',
	      method: 'get',
	      params: data
	    })
	},
	// 学术分类树
	scholarshipTree: function scholarshipTree() {
		return service({
			url: '/cloud/course/v1/admin/classification/tree',
			method: 'get'
		})
	},
	deleteCourse(params) {
		return service({
			url: '/cloud/course/v1/admin/course/delete',
			method: 'post',
			params: params
		})
	},
	/**
	 * [addCourse 添加课程]
	 * @param {[obj]} data [课程信息]
	 */
	addCourse(data) {
		return service({
			url: '/cloud/course/v1/admin/course/create',
			method: 'post',
			data: data
		})
	},
	editCourse(data) {
		return service({
			url: '/cloud/course/v1/admin/course/modify',
			method: 'post',
			data: data
		})
	},
	getCourseDetail(params) {
		return service({
			url: '/cloud/course/v1/admin/course/findById',
			method: 'get',
			params: params
		})
	},
	getCourseRelate(params) {
		return service({
			url: '/cloud/course/v1/admin/course/associationSourceList',
			method: 'get',
			params: params
		})
	},
	// 上下架
	courseSwitch(data) {
		return service({
			url: '/cloud/course/v1/admin/course/offline',
			method: 'post',
			params: data
		})
	},
    //分页获取医生课程学员列表
	getCourseMemberList: (data) => {
		return service({
			url: '/cloud/course/v1/admin/course/memberPageList',
			method: 'post',
			data: data
		})
	},
	/**
	 * [resetLive 重置直播]
	 * @param  {[obj]} params [id]
	 * @return {[obj]}
	 */
	resetLive(params) {
		return service({
			url: '/cloud/course/v1/admin/coursesource/reset',
			method: 'post',
			params: params
		})
	},
	// 导入学员列表
	getMemberList(params) {
		return service({
			url: '/cloud/uac/v1/users/doctors/search',
			method: 'get',
			params: params
		})
	},
	// 导入，列表形式
	exportList(params,data) {
		return service({
			url: '/cloud/course/v1/admin/course/importMemberList',
			method: 'post',
			params: params,
			data: data
		})
	},
	// 导入，excel形式
	excelList: v2 + '/cloud/course/v1/admin/course/importMemberExcel',
	/**
	* [export 导出学员列表]
	* @param  {[obj]} data [筛选条件]
	* @return {[obj]}
	*/
	exportExcel(data) {
	    let url = v2 + '/cloud/course/v1/admin/course/memberExport?' +
	      searchParamsFormatter(data)
	    window.location.href = url
	},
	/**
	 * 获取课程关联课程源二级表格-到课人数
	 */
	getCourseDaoKe(params) {
		return service({
			url: '/cloud/statistic/getSignCount',
			method: 'get',
			params: params
		})
	},
	/**
	 * 获取课程关联课程源二级表格-在线人数
	 */
	getCourseZaixian(params) {
		return service({
			url: '/cloud/statistic/getOnlineCount',
			method: 'get',
			params: params
		})
	},
	/**
	 * 获取课程关联课程源二级表格-回顾人数
	 */
	getCourseHuigu(params) {
		return service({
			url: '/cloud/statistic/getReviewCount',
			method: 'get',
			params: params
		})
	},
	/**
	 * 获取课程关联课程源二级表格-报名人数
	 */
	getCourseBaoming(params) {
		return service({
			url: '/cloud/course/v1/admin/course/courserealmember',
			method: 'get',
			params: params
		})
	},
  	//获取课程类型列表
  	getTypeList: (data) => {
	    return service({
	      url: '/cloud/course/v1/admin/course/product/type/list',
	      method: 'get',
	      params: data
	    })
	},
	// 学习统计表
  	findByCourseListPage: (data) => {
	    return service({
	      url: '/cloud/course/v1/admin/learn/findByCourseListPage',
	      method: 'get',
	      params: data
	    })
	},
	// 学习统计表 -- 导出
  	statisticExport: (data) => {
	    let url = v2 + '/cloud/course/v1/admin/learn/findByCourseListPage/exportForAdmin?' +
	      searchParamsFormatter(data)
	    window.location.href = url
	},
	// 学习明细表
  	findByPage: (data) => {
	    return service({
	      url: '/cloud/course/v1/admin/learn/findByPage',
	      method: 'get',
	      params: data
	    })
	},
	// 学习明细表 -- 柱状图
  	learnCharts: (data) => {
	    return service({
	      url: '/cloud/course/v1/admin/learn/findByCourseSourceInfo',
	      method: 'get',
	      params: data
	    })
	},
	// 学习明细表 -- 导出
  	statisticDetailExport: (data) => {
	    let url = v2 + '/cloud/course/v1/admin/learn/findByPage/exportForAdmin?' +
	      searchParamsFormatter(data)
	    window.location.href = url
	},
	//获取科室
	getdepartmentData:()=>{
		return service({
			url:'/cloud/uac/doctorManager/getDepartments',
			method:'get'
		})
	},
	//获取收款主体
	getCollectionSubject:(data)=>{
		return service({
			url:'/cloud/uac/v1/collection/subject/findByPage',
			method:'post',
			data
		})
	},
    getDisciplineList: (params) => {
        return service({
            url: '/cloud/course/v1/discipline/list',
            method: 'post',
			params
        })
    },
    getSubjectList: () => {
        return service({
            url: '/cloud/course/v1/subject/list',
            method: 'get'
        })
    },
	
	// 下载模板
	down: 'https://file.ibabygroup.cn/cms/file/import_member.xlsx'
}



// WEBPACK FOOTER //
// ./src/api/contentManage/docCourseManage.js